import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../redux/actions/configApi'; // Assumindo que a API está configurada nesse arquivo
import { useNavigate } from "react-router-dom";

// AsyncThunk para buscar as vendas
export const fetchVendas = createAsyncThunk('vendas/fetchVendas', async (page, { rejectWithValue }) => {
    try {
        const response = await api.get(`/orders?page=${page}`); 
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || 'Erro ao buscar vendas');
    }
});

// AsyncThunk para atualizar o status de uma venda
export const updateStatusVenda = createAsyncThunk(
    'vendas/updateStatusVenda',
    async ({ id, status }, { rejectWithValue }) => {
        try {
            const response = await api.put(`/orders/${id}`, { status }); 
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao atualizar status da venda');
        }
    }
);

//email de confirmação de compra
export const emailConfirmacaoVenda = createAsyncThunk(
    'vendas/emailConfirmacaoVenda',
    async (order_code, { rejectWithValue }) => {
        try {
            const response = await api.post(`/emailOrder`, { order_code }); 
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao atualizar status da venda');
        }
    }
);


const vendasSlice = createSlice({
   
    name: 'vendas',
    initialState: {
        vendas: [],
        loading: false,
        error: null,
        message:'',
        total: '',
        currentPage: 1
    },
    reducers: {}, // Não precisamos de reducers síncronos aqui
    extraReducers: (builder) => {
        builder
            // Fetch Vendas
            .addCase(fetchVendas.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVendas.fulfilled, (state, action) => {
                state.loading = false;
                state.vendas = action.payload.orders;
            })
            .addCase(fetchVendas.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                const navigate = useNavigate();
                if (action.payload?.message === "Unauthenticated.") {
                    navigate("/login"); // Use a navegação do React Router
                }
            })
            // Update Status Venda
            .addCase(updateStatusVenda.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateStatusVenda.fulfilled, (state, action) => {
                state.loading = false;
                const { order, message } = action.payload;
                state.message = message;
                state.vendas = order;
                
            })
            .addCase(updateStatusVenda.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(emailConfirmacaoVenda.fulfilled, (state, action) => {
                state.message = 'Email enviado com sucesso';
                console.log(state.message, 'state.message')
                //state.error = action.payload;
            });
    },
});

export default vendasSlice.reducer;
